"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const education_entry_1 = __importDefault(require("./education-entry"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Education = ({ training }) => {
    // do not render if data not present
    if (!training || training.length === 0) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ExpertiseSectionContainer, null,
        react_1.default.createElement(styles_1.ExpertiseSectionTitle, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.educationSectionTitle))),
        training.map((t, index) => {
            return (react_1.default.createElement(education_entry_1.default, { key: `${t.degree}${t.field_of_study}${t.graduation_year}${t.name}${t.type}${index}`, training: t }));
        })));
};
exports.default = Education;
//# sourceMappingURL=education.js.map